import React from 'react';
import PropTypes from 'prop-types';

const Alert = ({ title, description }) => (
  <div className="alert">
    {title && <h5 className="alert__title">{title}</h5>}
    <p className="alert__description">{description}</p>
  </div>
);

Alert.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node.isRequired
};

Alert.defaultProps = {
  title: null
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Common/Alert/Alert.js